import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {groupAll} from "../../../roles/groups";
import {defineMessage} from "react-intl";
import {AirportDataPage} from "../../../../../pages/General/AirportData/AirportDataPage";

const AirportDataRouteTitleMessage = defineMessage({
  id: "airportDataRoute.title",
  defaultMessage: "Airport Data",
});

export const airportData: RouteDescriptor<Route.airportData> = {
  route: Route.airportData,
  render: AirportDataPage,
  title: AirportDataRouteTitleMessage,
  path: "/airport-data",
  allowRoles: [
    ...groupAll,
  ],
  redirectToHomeRoles: [],
  showInSidebar: false,
};
